(() => {
  const config = document.getElementById('VoidReviewLabels');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const setText = (element, value) => { if (element.textContent !== value) element.textContent = value; };
  const format = (value, rating, count) => value.replace('__RATING__', rating).replace('__COUNT__', count);
  const update = () => {
    document.querySelectorAll('.jdgm-all-reviews-text__text').forEach(element => {
      const rating = Number(element.dataset.score);
      const count = Number(element.dataset.numberOfReviews);
      if (Number.isFinite(rating) && Number.isFinite(count)) {
        const text = format(labels.summary, rating.toLocaleString(document.documentElement.lang, {minimumFractionDigits:1,maximumFractionDigits:1}), count);
        setText(element, text);
        element.closest('a')?.setAttribute('aria-label', text);
      }
    });
    document.querySelectorAll('.jdgm-verified-by__text').forEach(element => setText(element, labels.verified));
    document.querySelectorAll('.jdgm-prev-badge').forEach(badge => {
      const count = Number(badge.dataset.numberOfReviews);
      const text = badge.querySelector('.jdgm-prev-badge__text');
      if (text && Number.isFinite(count)) setText(text, count ? format(labels.count, '', count) : labels.none);
    });
  };
  let pending = false;
  const observer = new MutationObserver(mutations => {
    if (pending || !mutations.some(mutation => mutation.target.parentElement?.closest('[class*="jdgm"]') || [...mutation.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[class*="jdgm"]') || node.querySelector?.('[class*="jdgm"]'))))) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; update(); });
  });
  observer.observe(document.body, {childList:true,subtree:true,characterData:true});
  update();
})();
